import axios from "axios";

import {
  showSessionExpiredModal,
} from "src/components/session-expired/SessionExpiredModal";

const API_URL =
  process.env.REACT_APP_API_URL ||
  "https://api.fvcakes.com/api";

const axiosInstance = axios.create({
  baseURL: API_URL,
});

/* ==========================================
   REQUEST INTERCEPTOR
========================================== */

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ==========================================
   RESPONSE INTERCEPTOR
========================================== */

let isSessionExpired = false;

axiosInstance.interceptors.response.use(
  (response) => response,

  (error) => {
    const status = error?.response?.status;

    if (status === 401 && !isSessionExpired) {
      isSessionExpired = true;

      // Show session expired modal
      showSessionExpiredModal();

      // Reset flag after redirect/modal closes
      const resetInterval = setInterval(() => {
        const token = localStorage.getItem("token");

        if (!token) {
          isSessionExpired = false;
          clearInterval(resetInterval);
        }
      }, 500);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;